export default __webpack_public_path__ + "static/media/cp_BannerAgotados_movil.140bad7a.jpg";